.ConvertedMaterialCost {
	justify-content: flex-end;
}
